if (!customElements.get('product-card-siblings')) {
  class ProductCardSiblings extends HTMLElement {
    constructor() {
      super();

      this.siblingItems = this.querySelectorAll('.product-siblings__item');
      this.productCard = this.closest('product-card');
      this.productCardTitle = this.productCard.querySelector('.product-card-title');
      this.productCardComparePrice = this.productCard.querySelector('.price del');
      this.productCardPrice = this.productCard.querySelector('.price ins .amount');
      this.productCardLink = this.productCard.querySelector('.product-featured-image-link');
      this.productCardQuickView = this.productCard.querySelector('quick-view');
      this.productCardPrimaryImg = this.productCard.querySelector('.product-primary-image');
      this.productCardSecondaryImg = this.productCard.querySelector('.product-secondary-image');
      this.siblingItems.forEach(siblingItem => siblingItem.addEventListener('click', this.handleSiblingClick.bind(this)));
    }

    handleSiblingClick(e) {
      if (e.currentTarget.className.includes('active')) {
        return;
      }

      this.querySelector('.product-siblings__item.active').classList.remove('active');
      const newSiblingEle = e.currentTarget;
      newSiblingEle.classList.add('active');

      this.productCardTitle.textContent = newSiblingEle.dataset.title;
      this.productCardPrice.textContent = newSiblingEle.dataset.price;
      this.productCardLink.href = newSiblingEle.dataset.handle;
      this.productCardTitle.href = newSiblingEle.dataset.handle;
      if (this.productCardQuickView) {
        this.productCardQuickView.dataset.productHandle = newSiblingEle.dataset.handle;
      }
      this.productCardPrimaryImg.src = newSiblingEle.dataset.primaryImg;
      this.productCardPrimaryImg.srcset = '';
      this.productCardSecondaryImg.src = newSiblingEle.dataset.secondaryImg;
      this.productCardSecondaryImg.srcset = '';

      this.cardBadges = this.productCard.querySelector('.product-card--badges');

      if (newSiblingEle.dataset.oos) {
        this.cardBadges.querySelector('.badge.out-of-stock')?.remove();
        const oosBadge = document.createElement('span');
        oosBadge.textContent = newSiblingEle.dataset.oos;
        oosBadge.classList.add('badge', 'out-of-stock');
        this.cardBadges.appendChild(oosBadge);
      } else {
        this.cardBadges.querySelector('.badge.out-of-stock')?.remove();
      }

      if (newSiblingEle.dataset.comparePrice) {
        if (this.productCardComparePrice) {
          this.productCardComparePrice.style.display = 'inline-block';
        } else {
          const span = document.createElement('span');
          span.classList.add('amount');
          span.textContent = newSiblingEle.dataset.comparePrice;

          const del = document.createElement('del');
          del.appendChild(span);

          this.productCard.querySelector('.price').prepend(del);
          this.productCardComparePrice = del;
        }
      } else {
        if (this.productCardComparePrice) {
          this.productCardComparePrice.style.display = 'none';
        }
      }
    }
  }

  customElements.define('product-card-siblings', ProductCardSiblings);
}